/**
 * Component: Cart add-on script
 * ------------------------------------------------------------------------------
 * Loosely coupled scripts for the Cart add-on functionality.
 *
 * @namespace productEngraving
 */

 import {debounce, on, decodeHTMLEntities} from '~/helpers/utils';
 import cssClasses from '~/helpers/cssClasses';
 import {banned_words} from '../components/banned_words'

 const selectors = {
    container: '[js-engraving="container"]',
    checkbox: '[js-engraving="checkbox"]',
    lineItemProperty: '[js-engraving="line-item-property"]',
    input: '[js-engraving="input"]',
    info: '[js-engraving="info"]',
    productEngraving: '[js-engraving="product-engraving"]',
    addToCart: '[js-product-form="addToCart"]',
    error: '[js-engraving="error"]',
    engravingTriggerMedia: '[js-engraving="triggerMedia"]',
}
export default () => {
    const nodeSelectors = {
        container: document.querySelector(selectors.container),
        checkbox: document.querySelector(selectors.checkbox),
        lineItemProperty: document.querySelector(selectors.lineItemProperty),
        input: document.querySelector(selectors.input),
        icon: document.querySelector(selectors.icon),
        info: document.querySelector(selectors.info),
        productEngraving: document.querySelector(selectors.productEngraving),
        addToCart: document.querySelector(selectors.addToCart),
        error: document.querySelector(selectors.error),
        engravingTriggerMedia: document.querySelector(selectors.engravingTriggerMedia),
    }


function init() {
    if (!theme.engraving.allow) {
        return;
        }
    setEventListeners();
}


/**
* Set event listeners.
*/
function setEventListeners() {
    on('click', nodeSelectors.checkbox, () => ToggleCheckbox());
    on('keyup', nodeSelectors.input, () => Typing());
    on('keydown', nodeSelectors.input, () => removeErrorInput(), );
}


/**
* Show input
* @param {Event} event - click event.
*/
function ToggleCheckbox() {
    if (nodeSelectors.checkbox.checked) {
        showInput()
        disableAddToCart()
        resetInput()
        inputFocus()
        nodeSelectors.engravingTriggerMedia.dataset.id = 0
        nodeSelectors.engravingTriggerMedia.dataset.image = window.firstImage
        
        
    }else {
        hideInput()
        enableAddToCart()
        removeErrorInput()
        removeProperties()
        nodeSelectors.engravingTriggerMedia.dataset.id = 1
        nodeSelectors.engravingTriggerMedia.dataset.image = window.engravingImage
        
        }
}

/**
* Typing
* @param {Event} event - keyup event.
*/
function Typing() {
    const regex = /^[a-zA-Z0-9.\ ]+$/;
    if (regex.test(nodeSelectors.input.value)) {
      checkBanWords()
    } else {
      haveErrorInput()
      disableAddToCart()
    }
}


/**
 * Add disable state to add to cart button.
 * @param {String} label - Text to use on button.
 */
function disableAddToCart(label = decodeHTMLEntities(theme.engraving.addToCart)) {
    nodeSelectors.addToCart.setAttribute('disabled', true);
    nodeSelectors.addToCart.innerText = label;
}

/**
 * Add disable state to add to cart button.
 * @param {String} label - Text to use on button.
 */
 function enableAddToCart(label = decodeHTMLEntities(theme.strings.addToCart)) {
    nodeSelectors.addToCart.removeAttribute('disabled', true);
    nodeSelectors.addToCart.innerText = label;
}

function hideInput() {
    nodeSelectors.lineItemProperty.classList.add(cssClasses.hidden)
}
function showInput() {
    nodeSelectors.lineItemProperty.classList.remove(cssClasses.hidden)
}
function haveErrorInput() {
  if (nodeSelectors.input.value !== '') {
    nodeSelectors.lineItemProperty.classList.add('errors')
    nodeSelectors.error.classList.remove(cssClasses.hidden)
    nodeSelectors.input.style.color = '#f64747'
    nodeSelectors.input.value = ''
    disableAddToCart();
  }
}
function removeErrorInput() {
    nodeSelectors.lineItemProperty.classList.remove('errors')
    nodeSelectors.error.classList.add(cssClasses.hidden)
    nodeSelectors.input.style.color = ''
    nodeSelectors.input.value = nodeSelectors.input.value
}


function checkBanWords() {
    for(var i=0; i<banned_words.length; i++)  {
        if (~nodeSelectors.input.value.toLowerCase().indexOf(banned_words[i])){
            haveErrorInput()
        }else {
            string => string.replace(/[\u{1f600}-\u{1f64f}]/gu, "");
            enableAddToCart()
        }
    }
}


function inputFocus() {
    nodeSelectors.input.focus()
}

function resetInput() {
    nodeSelectors.input.value = ''
    nodeSelectors.productEngraving.innerHTML = ``
}


function removeProperties() {
  nodeSelectors.productEngraving.innerHTML = `` 
}




/**
* Expose public interface.
*/
return Object.freeze({
init,
});
};